import React, { createContext, useContext, useState } from 'react';

const CompareContext = createContext();

export const CompareProvider = ({ children }) => {
  const [compareList, setCompareList] = useState([]);
  const [showComparison, setShowComparison] = useState(false);

  const addToCompare = (product) => {
    if (compareList.length >= 3) {
      alert('You can only compare up to 3 products at a time');
      return;
    }
    if (compareList.find(p => p.id === product.id)) {
      alert('This product is already in your comparison list');
      return;
    }
    setCompareList([...compareList, product]);
  };

  const removeFromCompare = (productId) => {
    setCompareList(compareList.filter(p => p.id !== productId));
  };

  const clearCompare = () => {
    setCompareList([]);
    setShowComparison(false);
  };

  const toggleComparison = () => {
    setShowComparison(!showComparison);
  };

  return (
    <CompareContext.Provider
      value={{
        compareList,
        addToCompare,
        removeFromCompare,
        clearCompare,
        showComparison,
        toggleComparison
      }}
    >
      {children}
    </CompareContext.Provider>
  );
};

export const useCompare = () => {
  const context = useContext(CompareContext);
  if (!context) {
    throw new Error('useCompare must be used within CompareProvider');
  }
  return context;
};
